import React, { useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Point2D } from '../planview2/GEMath';
import {
    PLAN_VIEW_RESIZE_EVENT_TYPE,
    PLAN_VIEW_PAINT_EVENT_TYPE,
    PlanViewRepaintEvent
} from '../planview2/PlanViewAdvanced2.PlanViewEvents';



function TourPlayerDrawViewPoints(props, ref)
{
    const { zIndexBase, planView, viewPoints, step } = props;

    const dimasz = 12;

    const drawArrow = (canvas, from, to, viewTransform, options) => {

        const svpFrom = from.matrixTransform(viewTransform);
        const svpTo = to.matrixTransform(viewTransform);

        const arrowAngle = Math.PI * 0.9;
        const ptTo = Point2D.make(svpTo);
        const d = ptTo.sub(Point2D.make(svpFrom)).normalize();
        const d0 = d.rotated(arrowAngle);
        const d1 = d.rotated(-arrowAngle);
        const arr0 = Point2D.make(ptTo).addVector(d0.getMultiplyScalar(dimasz));
        const arr1 = Point2D.make(ptTo).addVector(d1.getMultiplyScalar(dimasz));

        canvas.save();

        canvas.strokeStyle = 'black';
        canvas.fillStyle = 'black';
        canvas.lineWidth = 2;

        canvas.beginPath();
        canvas.moveTo(svpFrom.x, svpFrom.y);
        canvas.lineTo(svpTo.x, svpTo.y);
        canvas.stroke();

        canvas.beginPath();
        canvas.moveTo(arr0.x, arr0.y);
        canvas.lineTo(svpTo.x, svpTo.y);
        canvas.lineTo(arr1.x, arr1.y);
        canvas.fill();

        canvas.restore();
    };



    const planViewPaint = useCallback((e) => {

        const drawCtx = ref.current.getContext("2d");

        drawCtx.setTransform(1, 0, 0, 1, 0, 0);
        drawCtx.clearRect(0, 0, drawCtx.canvas.width, drawCtx.canvas.height);

        const tr = e.viewTransform;
        //const tr = pdfViewDataRef.current.viewTrMatrix.multiply(pdfViewDataRef.current.viewPointsTrafo);

        if (viewPoints.length > 1)
            for (let vi = 1; vi < viewPoints.length; ++vi) {
                drawArrow(drawCtx, viewPoints[vi-1], viewPoints[vi], e.viewTransform);
            }
        viewPoints.forEach((vp, index) => {
            if (index === step - 1)
                e.drawViewpoint(drawCtx, vp, tr, {
                    background:'transparent',
                    radius:4,
                    fill:'#E94F35',
                    stroke:'#703000'
                });
            else
                e.drawViewpoint(drawCtx, vp, tr, {
                    background:'transparent',
                    radius:4,
                });
        });
        // viewPoints.forEach((vp) => {
        //     e.drawViewpointLabel(drawCtx, vp, tr);
        // });
    }, [step]);


    const planViewResize = (e) => {
        ref.current.width = e.width;
        ref.current.height = e.height;
    };


    useEffect(() => {
        if (!(planView instanceof HTMLElement))
            return;

        planView.addEventListener(PLAN_VIEW_PAINT_EVENT_TYPE, planViewPaint);
        planView.addEventListener(PLAN_VIEW_RESIZE_EVENT_TYPE, planViewResize);

        const rc = planView.getBoundingClientRect();
        ref.current.width = rc.width;
        ref.current.height = rc.height;

        return () => {
            planView.removeEventListener(PLAN_VIEW_PAINT_EVENT_TYPE, planViewPaint);
            planView.removeEventListener(PLAN_VIEW_RESIZE_EVENT_TYPE, planViewResize);
        };
    }, [planView, planViewResize]);


    useEffect(() => {
        if (!(planView instanceof HTMLElement))
            return;

        planView.dispatchEvent(new PlanViewRepaintEvent());
    }, [ planView, step ]);


    return (
        <canvas ref={ref}
                width={1}
                height={1}
                style={{
                    position:'absolute',
                    left:0,
                    top:0,
                    zIndex:zIndexBase,
                    pointerEvents:'none'
                }}>
        </canvas>
    );
}


TourPlayerDrawViewPoints.propTypes = {
    planView:PropTypes.object.isRequired,
    viewPoints:PropTypes.array.isRequired,
    step: PropTypes.number.isRequired,
    zIndexBase:PropTypes.number,
}


TourPlayerDrawViewPoints.defaultProps = {
    zIndexBase:100,
}

export default React.forwardRef(TourPlayerDrawViewPoints);